const getGroupNameFromId = (groupByID) => {
  return groupByID ? groupByID.split(".")[0] : "";
};

export default getGroupNameFromId;
